import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { CompactModeProvider } from './hooks/useCompactMode';
import { UserPreferencesProvider } from './hooks/useUserPreferences';
import HomePage from './pages/HomePage';
import EventPage from './pages/EventPage';
import CreateEventPage from './pages/CreateEventPage';
import MyEventsPage from './pages/MyEventsPage';
import ProfilePage from './pages/ProfilePage';
import FeedbackManagementPage from "@/pages/FeedbackManagementPage.tsx";
import EventManagementPage from "@/pages/EventManagementPage.tsx";
import UserManagementPage from "@/pages/UserManagementPage.tsx";

function App() {
    return (
        <AuthProvider>
            <CompactModeProvider>
                <UserPreferencesProvider>
                    <Router>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/event/:eventId" element={<EventPage />} />
                            <Route path="/create-event" element={<CreateEventPage />} />
                            <Route path="/my-events" element={<MyEventsPage />} />
                            {/* Global profile route */}
                            <Route path="/profile" element={<ProfilePage />} />
                            {/* Event context profile route */}
                            <Route path="/profile/:eventId" element={<ProfilePage />} />
                            {/* Specific user profile in event context */}
                            <Route path="/profile/:eventId/:userId" element={<ProfilePage />} />
                            {/* Feedback routes */}
                            <Route path="/admin/feedback" element={<FeedbackManagementPage />} />
                            <Route path="/admin/events" element={<EventManagementPage />} />
                            <Route path="/admin/users" element={<UserManagementPage />} />
                        </Routes>
                    </Router>
                </UserPreferencesProvider>
            </CompactModeProvider>
        </AuthProvider>
    );
}

export default App;